/**
 * ADR-210 — keep a deep link across a sign-in.
 *
 * Mission Control runs no login: an unauthenticated visitor is sent to the
 * console, which comes back to Mission Control's ROOT with a token. Without help
 * a permanent file link (/files/<scope>/<path>) opened while signed out would be
 * lost on the way. The path is remembered for this tab (sessionStorage survives
 * the round trip to the console in the same tab) and restored once the token
 * checks out. When the console session is already live, App mints in place and
 * the URL is never touched, so none of this runs.
 *
 * Same-origin paths only: the stored value must start with a single "/", so a
 * crafted value cannot turn the restore into an open redirect.
 */
export const RETURN_KEY = 'mc_return_to'

/** Remember the current location, if it is a deep link worth keeping. */
export function rememberReturnPath(pathname: string, search: string, storage: Storage = sessionStorage): void {
  if (pathname === '/' || !isSafe(pathname)) return
  storage.setItem(RETURN_KEY, pathname + search)
}

/** The remembered path to restore, if we landed on the root. Always clears the key. */
export function takeReturnPath(currentPathname: string, storage: Storage = sessionStorage): string | null {
  const saved = storage.getItem(RETURN_KEY)
  if (saved === null) return null
  storage.removeItem(RETURN_KEY)
  if (currentPathname !== '/' || !isSafe(saved)) return null
  return saved
}

function isSafe(p: string): boolean {
  return p.startsWith('/') && !p.startsWith('//') && !p.includes('\\')
}
